var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNidDePoule(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "nid_de_poule",
    "data-name": "nid de poule",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 115.36 54.63",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{clip-path:url(#clip-path);}.cls-3{fill:#494949;}.cls-4{fill:#232323;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path",
    transform: "translate(-602 -2071.84)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M602,2104c0-6,10-15,20-18s32-6,40-4,12-2,19,1,12,12,20,13,13,10,4,19-66,21-92-1C605,2109,602,2110,602,2104Z"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "nid de poule") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M602,2104c0-6,10-15,20-18s32-6,40-4,12-2,19,1,12,12,20,13,13,10,4,19-66,21-92-1C605,2109,602,2110,602,2104Z",
    transform: "translate(-602 -2071.84)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M618,2087.49s4,1.51,6,1.51a45.92,45.92,0,0,0,10-1,66.38,66.38,0,0,1,13-1c3,0,11,2,15,1s16-2,20,2c4.47,4.47,4,6,10,8s5.6,1.2,8,3c4,3,6,2,7,6s0,5.7,0,5.7l5,.3s7-11,5-16-32-24-34-25-36,3-36,3l-37,10Z",
    transform: "translate(-602 -2071.84)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNidDePoule);
export default __webpack_public_path__ + "static/media/nid_de_poule.a984972f57c9eca74d8cbfd68979d456.svg";
export { ForwardRef as ReactComponent };